import React, { useEffect } from 'react';
import { Button } from '../ui/button';
import { useMobileMenuStore } from '../../store/useMobileMenuStore';

export const MobileMenu = (): JSX.Element => {
  const { isMenuOpen, toggleMenu, closeMenu } = useMobileMenuStore();
  const navItemsRight = ["Features", "Pricing", "Contact"];

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = element.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: offset, behavior: "smooth" });
    }
    closeMenu();
  };

  return (
    <div
      className={`
        fixed inset-0 bg-black/95 backdrop-blur-md z-[55] transform transition-all duration-500
        flex flex-col items-center justify-center gap-10
        ${isMenuOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0 pointer-events-none"}
      `}
    >
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 z-[60] w-10 h-10 flex items-center justify-center"
        onClick={toggleMenu}
        aria-label="Close menu"
      >
        <div className="relative w-6 h-5">
          <span className="absolute w-full h-0.5 bg-white transform transition duration-300 rotate-45 top-2" />
          <span className="absolute w-full h-0.5 bg-white transform transition duration-300 -rotate-45 top-2" />
        </div>
      </button>

      {navItemsRight.map((item, index) => (
        <a
          key={index}
          href={`#${item.toLowerCase()}`}
          onClick={(e) => handleScroll(e, item.toLowerCase())}
          className={`
            font-satoshi text-white/90 hover:text-white text-2xl transition duration-300 transform
            ${isMenuOpen ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}
          `}
          style={{ transitionDelay: `${index * 100}ms` }}
        >
          {item}
        </a>
      ))}
      <Button
        className={`
          bg-white text-gray-900 rounded-[55px] px-[34px] py-3.5 font-satoshi font-bold text-base hover:bg-gray-100
          transition transform ${isMenuOpen ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}
        `}
        style={{ transitionDelay: "300ms" }}
      >
        Get started
      </Button>
    </div>
  );
};